export const ESSENTIAL_DISCOUNT = 0.7;
export const STANDARD_DISCOUNT = 0.8;
export const currency = 'USD';
export const COMBINED_USERS = 500;

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30MaximoSaaS = '30BH6';
